import React, { useState } from "react";
import { Box, getColor, Icons, Modal, Typography } from "fds";
import "../index.scss";
import classNames from "classnames";
import ProfileTab from "./ProfileTab";
import ChangePWTab from "./ChangePWTab";
import LinkAppTab from "./LinkAppTab";
import AlarmTab from "./AlarmTab";
import { t } from "i18next";
import utilsCommon from "../../../shared/utils/common";

interface ProfileModalProps {
  open: boolean;
  onClose: () => void;
  startTab: "ACCOUNT" | "ALARM" | "APP";
}

const ProfileModal: React.FC<ProfileModalProps> = ({
  open,
  onClose,
  startTab,
}) => {
  /* 설정 탭
   * profile: 프로필
   * password: 보안
   * plusApp: 서비스 연동 => zoom 과 linkApp 조건 모두 만족시 표시
   * alarm: 알림
   */
  const tabs = [
    {
      id: "profile",
      name: t("header.profile.title"),
      icon: <Icons variant="fill" label="user" />,
    },
    {
      id: "password",
      name: t("header.security.title"),
      icon: <Icons variant="fill" label="lock" />,
    },
    {
      id: "plusApp",
      name: t("header.linkApp.title"),
      isHidden:
        !utilsCommon.checkMenuAvailable("zoom") &&
        window.eco.companyName !== "linkApp",
      icon: <Icons variant="fill" label="plusApp" />,
    },
    {
      id: "alarm",
      name: t("header.setAlarm.title"),
      icon: <Icons variant="fill" label="notification" />,
    },
  ];
  /** State 정리 */
  const [tab, changeTab] = useState(
    startTab === "ALARM" ? "alarm" : startTab === "APP" ? "plusApp" : "profile"
  ); // 탭

  /** 함수 정리 */
  /** 주어진 탭에 맞게 페이지 표시 */
  const renderSettingPage = () => {
    switch (tab) {
      case "profile":
        return <ProfileTab open={tab === "profile"} />;
      case "password":
        return <ChangePWTab open={tab === "password"} />;
      case "plusApp":
        return <LinkAppTab open={tab === "plusApp"} />;
      default:
        return <AlarmTab open={tab === "alarm"} />;
    }
  };
  return (
    <Modal
      open={open}
      title={t("common.setting")}
      onClose={onClose}
      classes="profileModal"
      bodyHeight={644}
      width={816}
      body={
        <Box width="100%" height={"100%"}>
          <Box direction="column" classes="profileModal-sidemenu">
            {tabs
              .filter((item) => !item.isHidden)
              .map((item) => (
                <Box
                  classes={classNames("sidemenu-button", {
                    selected: tab.includes(item.id),
                  })}
                  onClick={() => changeTab(item.id)}
                >
                  {item.icon}
                  <Typography
                    classes="mg ml-12"
                    type="body2_rg"
                    exactColor={getColor("COLOR_TEXT_SECONDARY")}
                  >
                    {item.name}
                  </Typography>
                </Box>
              ))}
          </Box>
          {renderSettingPage()}
        </Box>
      }
      isFooter={false}
    />
  );
};

export default ProfileModal;
